import { gdprCookiesForm } from "./gdprCookiesForm";
import { requestQuote } from './requestQuote'

import PhotoSwipeLightbox from 'photoswipe/lightbox';
// import 'photoswipe/style.css';

/**
 * GDPR cookies selection form
 */
gdprCookiesForm();

/**
 * Request quote
 */
requestQuote();


/**
 * Language menu
 */
const languageMenu = () => {
  const langShowCta = document.getElementById('js-lang')
  const langList = document.querySelector('[data-lang-list]')
  if (langList && langShowCta) {
    langShowCta.addEventListener('click', (event) => {
      event.stopPropagation()
      langList.classList.toggle('main-header__lang-list--active')
    })
    window.addEventListener('click', () => {
      langList.classList.remove('main-header__lang-list--active')
    })
  }
}
languageMenu()

/**
 * Cookies bar
 */
const cookieBar = () => {
  const gdprApprove = document.getElementById('gdpr-approve')
  if (gdprApprove) {
    gdprApprove.addEventListener('click', () => {
      localStorage.setItem('gtm', 'analytics')
      window.location.reload()
    })
  }
  if (!localStorage.getItem('gtm')) {
    const cookieBar = document.querySelector('.cookies-bar')
    if (cookieBar) {
      cookieBar.classList.remove('hidden')
    }
  }

  // remove gtm from localstorage, if value is not equal to any presented value
  const ls = localStorage.getItem('gtm')
  if (!(ls === 'default' || ls === 'analytics')) {
    localStorage.removeItem('gtm')
  }
}
cookieBar()


/**
 * PhotoSwipe lightbox for #gallery
 */
const galleryLightbox = new PhotoSwipeLightbox({
  gallery: '.article-gallery',
  children: 'a',
  pswpModule: () => import('photoswipe')
});
galleryLightbox.init();

/**
 * PhotoSwipe lightbox for .editor images with links
 */
const editorLightbox = new PhotoSwipeLightbox({
  gallery: '.wp-block-image',
  children: 'a',
  pswpModule: () => import('photoswipe')
});
editorLightbox.init();


/**
 * Set data-pswp-width and data-pswp-height for .editor images with links
 */
document.querySelectorAll('.editor a img').forEach((img) => {
  const link = img.parentElement;
  if (link && link.tagName === 'A') {
    const image = new Image();
    image.src = (img as HTMLImageElement).src;
    image.onload = () => {
      link.setAttribute('data-pswp-width', image.width.toString());
      link.setAttribute('data-pswp-height', image.height.toString());
    };
  }
});


/**
 * WP ACF Block - Show more details
 */
const showMoreDetails = () => {
  const showMoreDetailsLinks = document.querySelectorAll('[data-show-more-details]');
  showMoreDetailsLinks.forEach((detail) => {
    const link = detail.querySelector('[data-show-more-details-link]');
    const target = detail.querySelector('[data-show-more-details-target]');
    const hideButtonAfterClick = document.querySelector('[data-hide-button-after-click]') ?? null;
    link?.addEventListener('click', (event) => {
      event.preventDefault();
      if (hideButtonAfterClick) {
        hideButtonAfterClick.classList.add('hidden');
      }
      target?.classList.toggle('hidden');
      link?.classList.toggle('show-more-details__button--active');
    });
  });
}
showMoreDetails();

/**
 * WP ACF Block - Show full list
 */
const showFullList = () => {
  const showFullListLinks = document.querySelectorAll('[data-show-full-list]');
  showFullListLinks.forEach((list) => {
    const short = list.querySelector('[data-show-full-list-short]');
    const full = list.querySelector('[data-show-full-list-full]');
    const button = list.querySelector('[data-show-full-list-button]');
    const hideButtonAfterClick = document.querySelector('[data-hide-button-after-click]') ?? null;
    button?.addEventListener('click', (event) => {
      event.preventDefault();
      if (hideButtonAfterClick) {
        hideButtonAfterClick.classList.add('hidden');
      }
      short?.classList.toggle('hidden');
      full?.classList.toggle('hidden');
      button?.classList.toggle('show-more-details__button--active');
    });
  });
}
showFullList();


document.addEventListener("DOMContentLoaded", function() {

  /**
   * Rental gallery
   */
  const RentalGallery = () => {
    const openGalleryLink = document.querySelector('[data-rental-gallery-link]');
    const galleryAnchor = document.querySelector('[data-rental-gallery-anchor]');
    const galleryWrapper = document.querySelector('[data-rental-gallery-wrapper]');

    if (openGalleryLink && galleryWrapper) {

      openGalleryLink.addEventListener('click', function(event) {

        // scroll to galleryAnchor
        galleryAnchor?.scrollIntoView({behavior: 'smooth'});

        event.preventDefault();
        const firstImageLink = galleryWrapper.querySelector('a');
        if (firstImageLink) {
          firstImageLink.click();
        }
      });
    }
  }
  RentalGallery();


});
